import type { MailboxInfo } from "owa-client-types";
import { action } from "satcheljs";

export interface OnCopilotSettingsFetchCompleteActionMessage {
    mailboxInfo: MailboxInfo;
}

export const onCopilotSettingsFetchComplete: (mailboxInfo: MailboxInfo) => OnCopilotSettingsFetchCompleteActionMessage = action("onCopilotSettingsFetchComplete", (mailboxInfo: MailboxInfo): OnCopilotSettingsFetchCompleteActionMessage => ({ mailboxInfo }));
